import React from 'react';
import { Table, Badge } from 'react-bootstrap';
import { formatAmount, formatDateTime } from '../../../_metronic/utils/utils';
import AdditionalPaymentDetails from './AdditionalPaymentDetails';

const styles = {
  header: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#0f172a',
    backgroundColor: '#f8fafc',
    padding: '12px 18px',
    borderRadius: '12px 12px 0 0',
    borderBottom: '1px solid #cbd5e1',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  card: {
    border: '1px solid #e2e8f0',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
    marginBottom: '28px',
    backgroundColor: '#fff'
  },
  tableCell: {
    fontSize: '13px',
    color: '#334155',
    verticalAlign: 'middle',
    padding: '14px 18px',
    borderBottom: '1px solid #f1f5f9'
  },
  badge: (mode) => {
    switch (mode) {
      case 'ONLINE': return 'primary';
      case 'CASH': return 'success';
      case 'CHEQUE': return 'warning';
      default: return 'info';
    }
  },
  directionBadge: (direction) => {
    return {
      fontSize: '10px',
      fontWeight: '700',
      padding: '4px 10px',
      borderRadius: '20px',
      backgroundColor: direction === 'CREDIT' ? '#e8f5e9' : '#fdecea',
      color: direction === 'CREDIT' ? '#2e7d32' : '#c62828',
      border: `1px solid ${direction === 'CREDIT' ? '#c8e6c9' : '#ffcdd2'}`,
      display: 'inline-block'
    };
  }
};

export const EstimatePaymentsHistory = ({ payments }) => {
  if (!payments || payments.length === 0) {
    return (
      <div style={styles.card}>
        <div style={styles.header}>
          <i className="flaticon-piggy-bank text-primary" style={{ fontSize: '16px' }}></i>
          <span>Payment Transactions</span>
        </div>
        <div className="text-muted text-center py-4" style={{ fontSize: '13px' }}>
          No payments recorded for this estimate yet.
        </div>
      </div>
    );
  }

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <i className="flaticon-piggy-bank text-primary" style={{ fontSize: '16px' }}></i>
        <span style={{ fontWeight: '700', color: '#1e293b' }}>Payment Transactions ({payments.length})</span>
      </div>
      <div className="table-responsive">
        <Table hover style={{ marginBottom: 0, borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8fafc', borderBottom: '1px solid #cbd5e1' }}>
              <th style={{ ...styles.tableCell, fontWeight: '600', color: '#475569' }}>Date &amp; Time</th>
              <th style={{ ...styles.tableCell, fontWeight: '600', color: '#475569' }}>User Name</th>
              <th style={{ ...styles.tableCell, fontWeight: '600', color: '#475569', textAlign: 'center' }}>Direction</th>
              <th style={{ ...styles.tableCell, fontWeight: '600', color: '#475569', textAlign: 'center' }}>Mode</th>
              <th style={{ ...styles.tableCell, fontWeight: '600', color: '#475569' }}>Reference / Details</th>
              <th style={{ ...styles.tableCell, fontWeight: '600', color: '#475569', textAlign: 'right' }}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((item) => {
              const info = item.paymentGatewayProperties ? (item.paymentGatewayProperties.description || item.paymentGatewayProperties.productinfo || '') : '';
              return (
                <tr key={item.id} style={{ transition: 'background-color 0.2s' }}>
                  <td style={styles.tableCell}>{formatDateTime(item.datetime)}</td>
                  <td style={styles.tableCell}>
                    <span style={{ fontWeight: '600', color: '#0f172a' }}>
                      {item.user ? item.user.fullName : '-'}
                    </span>
                  </td>
                  <td style={{ ...styles.tableCell, textAlign: 'center' }}>
                    <span style={styles.directionBadge(item.direction)}>
                      {item.direction}
                    </span>
                  </td>
                  <td style={{ ...styles.tableCell, textAlign: 'center' }}>
                    <Badge variant={styles.badge(item.mode)} style={{ fontSize: '10px', padding: '5px 10px', borderRadius: '4px' }}>
                      {item.mode}
                    </Badge>
                  </td>
                  <td style={styles.tableCell}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <span>Ref: <code style={{ color: '#0f172a', fontWeight: '500' }}>{item.reference || 'N/A'}</code></span>
                      {info && <span className="text-muted" style={{ fontSize: '11px' }}>{info}</span>}
                      {item.paymentGatewayProperties && (
                        <div style={{ marginTop: '2px' }}>
                          <AdditionalPaymentDetails paymentDetails={item.paymentGatewayProperties} />
                        </div>
                      )}
                    </div>
                  </td>
                  <td style={{ ...styles.tableCell, textAlign: 'right', fontWeight: '700', fontSize: '14px', color: item.direction === 'CREDIT' ? '#16a34a' : '#dc2626' }}>
                    {formatAmount(item.amount, item.currency)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default EstimatePaymentsHistory;
